/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Delivery_Distance_LabelInputs */

const en_delivery_distance_label = /** @type {(inputs: Delivery_Distance_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Distance`)
};

const es_delivery_distance_label = /** @type {(inputs: Delivery_Distance_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Distancia`)
};

const fr_delivery_distance_label = /** @type {(inputs: Delivery_Distance_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Distance`)
};

const de_delivery_distance_label = /** @type {(inputs: Delivery_Distance_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entfernung`)
};

const id_delivery_distance_label = /** @type {(inputs: Delivery_Distance_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jarak`)
};

/** @type {(inputs: Delivery_Distance_LabelInputs) => LocalizedString} */
const ja_delivery_distance_label = en_delivery_distance_label;

/** @type {(inputs: Delivery_Distance_LabelInputs) => LocalizedString} */
const zh_delivery_distance_label = en_delivery_distance_label;

/** @type {(inputs: Delivery_Distance_LabelInputs) => LocalizedString} */
const ar_delivery_distance_label = en_delivery_distance_label;

/** @type {(inputs: Delivery_Distance_LabelInputs) => LocalizedString} */
const it_delivery_distance_label = en_delivery_distance_label;

/** @type {(inputs: Delivery_Distance_LabelInputs) => LocalizedString} */
const ru_delivery_distance_label = en_delivery_distance_label;

/** @type {(inputs: Delivery_Distance_LabelInputs) => LocalizedString} */
const pt_delivery_distance_label = en_delivery_distance_label;

/** @type {(inputs: Delivery_Distance_LabelInputs) => LocalizedString} */
const ko_delivery_distance_label = en_delivery_distance_label;

/**
* | output |
* | --- |
* | "Distance" |
*
* @param {Delivery_Distance_LabelInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const delivery_distance_label = /** @type {((inputs?: Delivery_Distance_LabelInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Delivery_Distance_LabelInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_delivery_distance_label(inputs)
	if (locale === "es") return es_delivery_distance_label(inputs)
	if (locale === "fr") return fr_delivery_distance_label(inputs)
	if (locale === "de") return de_delivery_distance_label(inputs)
	if (locale === "ja") return ja_delivery_distance_label(inputs)
	if (locale === "zh") return zh_delivery_distance_label(inputs)
	if (locale === "ar") return ar_delivery_distance_label(inputs)
	if (locale === "id") return id_delivery_distance_label(inputs)
	if (locale === "it") return it_delivery_distance_label(inputs)
	if (locale === "ru") return ru_delivery_distance_label(inputs)
	if (locale === "pt") return pt_delivery_distance_label(inputs)
	return ko_delivery_distance_label(inputs)
});